import React from 'react';
import './../Style/FAQs2027.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const FAQs2027 = () => {
  // FAQ Items Data Array
  const faqData = [
    {
      question: "In which mode will NEET 2027 be conducted?",
      answer: "NEET 2027 will be conducted offline (pen-paper mode) with answers to be filled on OMR sheets."
    },
    {
      question: "Will NEET 2027 be conducted twice a year?",
      answer: "No, this exam is conducted only once a year."
    },
    {
      question: "How many times can one attempt NEET 2027?",
      answer: "There is no limit on the number of attempts, you must be 17 years of age or above."
    },
    {
      question: "Who conducts NEET 2027?",
      answer: "National Testing Agency (NTA) conducts this exam."
    },
    {
      question: "Can I appear for NEET 2027 if I have taken a gap year between 11th and 12th?",
      answer: "Yes, you can."
    },
    {
      question: "What should be the minimum age?",
      answer: "Must have completed 17 years of age as on 31st December of the exam year."
    },
    {
      question: "What is the minimum eligibility?",
      answer: "12th is mandatory with Physics, Chemistry, Biology and English, and at least 50% marks for General (40% for OBC/SC/ST)."
    },
    {
      question: "What to do if there is a mistake in the admit card?",
      answer: "Immediately email NTA: neetug-nta@nic.in"
    }
  ];

  return (
    <div className="neetfaqs-container">


      <TopNavbar name="NEET FAQs"  ></TopNavbar>
      <TopHeader name="NEET FAQs" ></TopHeader>

      {/* Main Content Body */}
      <main className="neetfaqs-content">
        <h2 className="neetfaqs-main-title">NEET 2027 : FAQs</h2>

        <p className="neetfaqs-paragraph">
          NEET (National Eligibility cum Entrance Test) is the only national level medical entrance exam in India for admission to MBBS, BDS, BAMS, BHMS and other medical courses[cite: 18]. After the implementation of NMC Act, now AIIMS and JIPMER admissions are also done through NEET[cite: 18].
        </p>

        <p className="neetfaqs-paragraph">
          Many students have questions about NEET 2027 – here are the answers to all your important questions[cite: 18].
        </p>

        {/* FAQ List */}
        <div className="neetfaqs-list">
          {faqData.map((faq, index) => (
            <div key={index} className="neetfaqs-item">
              <h3 className="neetfaqs-question">
                <span className="neetfaqs-label">Q: </span>
                {faq.question}
              </h3>
              <p className="neetfaqs-answer">
                <span className="neetfaqs-label">A: </span>
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </main>


    </div>
  );
};

export default FAQs2027;